/**
 * TanStack Query hooks for `ai-powered-fraud-algorithms`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	aiPoweredFraudAlgorithmsQueryKeys,
	type CreateAiPoweredFraudAlgorithmsBody,
	type ListAiPoweredFraudAlgorithmsResponse,
	type AiPoweredFraudAlgorithmsRow,
} from "./api";

export function useAiPoweredFraudAlgorithmsList(): UseQueryResult<ListAiPoweredFraudAlgorithmsResponse, Error> {
	return useQuery({
		queryKey: aiPoweredFraudAlgorithmsQueryKeys.list(),
		queryFn: list,
	});
}

export function useAiPoweredFraudAlgorithmsCreate(): UseMutationResult<AiPoweredFraudAlgorithmsRow, Error, CreateAiPoweredFraudAlgorithmsBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: aiPoweredFraudAlgorithmsQueryKeys.all });
		},
	});
}

export function useAiPoweredFraudAlgorithmsDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: aiPoweredFraudAlgorithmsQueryKeys.all });
		},
	});
}
